var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-tool-keyboard"},[_c('ul',[_vm._l((_vm.keys),function(val,index){return _c('li',{key:index,style:(_vm.style),on:{"click":function($event){return _vm.keyUpHandle($event)}}},[_vm._v(" "+_vm._s(val)+" ")])}),_c('li',{staticClass:"del",style:(_vm.style),on:{"click":_vm.delHandle}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }